import React from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  Accordion,
  Card,
  Button,
} from 'react-bootstrap';
import './SearchIndicationPage.scss';
import { SearchIndicationSVG } from 'src/Admin/img/SearchIndicatorSVG';
const SearchIndicationComponent = ({ mainLabel = '', subLabel = '' }) => {
  return (
    <Container className="Search-Container pl-0">
      <Row className="Search-Row">
        <Col className="Search-Col">
          <SearchIndicationSVG />
        </Col>
      </Row>
      <Row className="Search-Row">
        <Col className="Search-Col">
          <div>
            {mainLabel
              ? mainLabel
              : 'Start typing <Name,Tax ID, Specialty or NPI> to search'}
          </div>
        </Col>
        <Col>
          {subLabel
            ? subLabel
            : 'Enter a search criteria and apply filters for better search results.'}
        </Col>
      </Row>
    </Container>
  );
};
export default SearchIndicationComponent;
